import instance from './instance';

export const fetchAiSuggestionWorkspaceItems = ({ workspaceId }) =>
  instance.get(`/workspaces/${workspaceId}/ai_suggestion_workspace_items`);

export const createNewAiSuggestionWorkspaceeItems = ({ workspaceId }) =>
  instance.post(`/workspaces/${workspaceId}/ai_suggestion_workspace_items/regenerate`);

export const createNewAiSuggestionWorkspaceeItemsPoll = ({ workspaceId }) =>
  instance.get(`/workspaces/${workspaceId}/ai_suggestion_workspace_items/regenerate_poll`);

export const acceptAiSuggestionWorkspaceItem = ({ workspaceId, aiSuggestionWorkspaceItemSlug }) =>
  instance.patch(`/workspaces/${workspaceId}/ai_suggestion_workspace_items/${aiSuggestionWorkspaceItemSlug}/accept`);

export const rejectAiSuggestionWorkspaceItem = ({ workspaceId, aiSuggestionWorkspaceItemSlug }) =>
  instance.patch(`/workspaces/${workspaceId}/ai_suggestion_workspace_items/${aiSuggestionWorkspaceItemSlug}/reject`);
